import { Component, OnInit } from '@angular/core';
import { RxjsService } from '@app/shared/services';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/api';

@Component({
  selector: 'app-primeng-video-dialog',
  templateUrl: './primeng-video-dialog.component.html'
})
export class PrimengVideoDialogComponent implements OnInit {

  // get the component instance to have access to plyr instance
  // or get it from plyrInit event
  constructor(public config: DynamicDialogConfig,
    public dialogRef: DynamicDialogRef,
    private rxjsService: RxjsService) {
  }

  ngOnInit(): void {
    this.rxjsService.setGlobalLoaderProperty(false);
    this.rxjsService.setDialogOpenProperty(true);
  }

  btnCloseClick() {
    this.dialogRef.close(false);
    this.rxjsService.setDialogOpenProperty(false);
  }
}

